import { Alert, Button, Skeleton, Stack, TableCell, TextField, Typography } from '@mui/material';
import { AssignedDoctorsCells, AssignedUsersCells, assignUser, getAssignedDoctors, getAssignedUsers, getUserActivity, getUsers, UserActivityCells } from 'framework/user';
import useFetchSection from 'hooks/useFetchSection';
import List from '../List';
import EmptyContent from 'components/EmptyContent';
import BlindsClosedIcon from "@mui/icons-material/BlindsClosed";
import { IAssignedDoctors, IAssignedUsers, IUser, IUserActivity, WearLogs } from 'models/user';
import { useEffect, useState } from 'react';
import { useAlert } from 'contexts/alertContext';
import { QueryClient, useMutation } from 'react-query';
import { formatDate } from 'helpers';
import { format } from 'date-fns';

interface Props {
  slugId: string
}

function getTodayString() {
  return format(new Date(), 'yyyy-MM-dd');
}

function UserActivity({ slugId }: Props) {
  const [filterDate, setFilterDate] = useState<string>(getTodayString());
  const {
    loading,
    data: Activity,
    error,
    revalidate,
  } = useFetchSection({
    fetchData: () => getUserActivity(`${slugId}${filterDate && `/${filterDate}`}`),
    fetchPermission: async () => null,
    section: "User Activity"
  });


  useEffect(() => {
    revalidate();
  }, [filterDate]);

  if (loading)
    return (
      <Stack spacing={2} p={2}>
        {Array.from({ length: 10 }).map((_, i) => (
          <Skeleton variant="rectangular" key={i} width="100%" height={30} />
        ))}
      </Stack>
    );

  if (error) return (
    <Alert severity="error">404 - Page not found</Alert>
  )

  const handleDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFilterDate(e.target.value);
  };

  const getBodyCells = (row: WearLogs) => {
    let cells = Object.keys(row).map((key: string, i: number) => {

      if (key === "startTime")
        return {
          id: "startTime",
          element: (
            <TableCell align={"left"} key={i}><Typography variant="body2">{formatDate(row?.startTime)}</Typography></TableCell>
          ),
        };

      if (key === "endTime")
        return {
          id: "endTime",
          element: (
            <TableCell align={"left"} key={i}>
              <Typography variant="body2">{formatDate(row?.endTime)}</Typography>
            </TableCell>
          ),
        };
      if (key === "durationMinutes")
        return {
          id: "durationMinutes",
          element: (
            <TableCell align={"left"} key={i}>
              <Typography variant="body2">{row?.durationMinutes}</Typography>
            </TableCell>
          ),
        };

      if (key === "manualEntry")
        return {
          id: "manualEntry",
          element: (
            <TableCell align={"left"} key={i}>
              <Typography variant="body2">{row?.manualEntry ? "True" : "False"}</Typography>
            </TableCell>
          ),
        };

      if (key === "status")
        return {
          id: "status",
          element: (
            <TableCell align={"left"} key={i}>
              <Typography variant="body2">{row?.status}</Typography>
            </TableCell>
          ),
        };

    });
    return cells;
  };

  return (
    <div>
      <Stack direction="row" spacing={2} mb={2} mt={4}>
        <TextField
          label="Filter by Date"
          type="date"
          value={filterDate}
          onChange={handleDateChange}
          InputLabelProps={{ shrink: true }}
          fullWidth
        />
      </Stack>

      {Activity!.wearLogs.length > 0 && (
        <List
          headCells={UserActivityCells}
          data={Activity!.wearLogs}
          getBodyCells={getBodyCells}
          canEdit={false}
        />
      )}
      {(!Activity!.wearLogs || Activity!.wearLogs.length === 0) &&

        <EmptyContent
          icon={<BlindsClosedIcon sx={{ fontSize: "3.5rem " }} />}
          header={"No User Activities"}
          message={`No User Activities Yet`}
        />
      }

    </div>
  )
}

export default UserActivity